import './FundItem.sass';
import './ETFIndexTrack.sass';
import { useArticles } from '../api';
import { useMemo, useState } from 'react';
import { useETFIndexTrack } from '../api';
import Breadcrumbs from '../components/Breadcrumbs';
import Hero from '../components/Hero';
import Meta from '../components/Meta';

const ETFIndexTrack = (props) => {
	const { routeData } = props;
	const { breadcrumbs } = useArticles(routeData.guid, routeData.route);
	const [currentTab, setCurrentTab] = useState('');
	const { apiData, isLoading, isError } = useETFIndexTrack(currentTab);

	const currentGroup = useMemo(() => {
		const result = [];

		if (apiData) {

			for (let index = 0; index < apiData.length; index++) {
				const item = apiData[index];

				if (item) {
					const getDirection = (str) => {
						const prep = str.replace('%', '');
						const num = Number(prep);

						if (num && num > 0) return 'bull';
						if (num && num < 0) return 'bear';

						return '';
					}

					result.push({
						name: (item.ec312 === 1 ? '*' : '') + item.twNameFull,
						date: item.navDate,
						value: item.nav,
						dayChange: item.yChangeRange,
						dayChangeDirection: getDirection(item.yChangeRange),
						rowspan: true,
						dayDiff: item.trackingDiff,
						dayDiffDirection: getDirection(item.trackingDiff),
						baseValue: item.yyNav,
						yearChange: item.yChange,
						yearChangeDirection: getDirection(item.yChange),
						yearDiff: item.yTrackingDiff,
						yearDiffDirection: getDirection(item.yTrackingDiff),
					});

					result.push({
						name: item.indexName,
						date: item.navDate,
						value: item.iNav,
						dayChange: item.iChangeRange,
						dayChangeDirection: getDirection(item.iChangeRange),
						rowspan: false,
						dayDiff: null,
						baseValue: item.iyyNav,
						yearChange: item.iyChangeRange,
						yearChangeDirection: getDirection(item.iyChangeRange),
						yearDiff: null,
					});
				}
			}


		}

		return result;

	}, [apiData]);

	return (
		<div className='FundItem' id='ETFIndexTrack'>
			<Meta data={routeData} />
			<Hero data={breadcrumbs} />
			<Breadcrumbs data={breadcrumbs} />

			<div className='common-pad-wrap'>
				<div className='tabs-wrap'>
					<div className='heading'>計算幣別</div>

					<div
						className={`tab ${currentTab === '' ? 'active' : ''}`}
						onClick={() => { setCurrentTab(''); }}>
						台幣
					</div>

					<div
						className={`tab ${currentTab === '1' ? 'active' : ''}`}
						onClick={() => { setCurrentTab('1'); }}>
						原幣
					</div>
				</div>

				{(isLoading || isError) ? null : (
					<div className='big-wrap'>
						<div className='table-wrap'>
							<table>
								<thead>
									<tr>
										<th className='left wrap'>基金/標的指數名稱</th>
										<th>基準日</th>
										<th>淨值/指數</th>
										<th>當日漲跌幅</th>
										<th>
											當日追蹤 偏<br />
											離度 (A)-(B)
										</th>
										<th>
											基準淨值/
											<br />
											指數 <span>註1</span>
										</th>
										<th>
											今年以來 漲<br />跌幅 <span>註2</span>
										</th>
										<th>
											今年以來 追蹤偏
											<br />
											離度 (C)-(D)
										</th>
									</tr>
								</thead>

								<tbody>
									{currentGroup.map((group, index) => {
										const { baseValue, date, dayChange, dayChangeDirection, dayDiff, dayDiffDirection, name, rowspan, value, yearChange, yearChangeDirection, yearDiff, yearDiffDirection } = group;

										return (
											<tr key={`row${index}`}>
												<td className='left wrap'>{name}</td>
												<td>{date}</td>
												<td>{value}</td>
												<td>
													<div className={`range ${dayChangeDirection}`}>
														<div className='text'>{dayChange}</div>
														<div className='icon'></div>
														<div className='type'>&nbsp;({rowspan ? 'A' : 'B'})</div>
													</div>
												</td>
												{rowspan ? (
													<td rowSpan='2'>
														<div className={`range ${dayDiffDirection}`}>
															<div className='text'>{dayDiff}</div>
															<div className='icon'></div>
														</div>
													</td>
												) : null}
												<td>{baseValue}</td>
												<td>
													<div className={`range ${yearChangeDirection}`}>
														<div className='text'>{yearChange}</div>
														<div className='icon'></div>
														<div className='type'>&nbsp;({rowspan ? 'C' : 'D'})</div>
													</div>
												</td>
												{rowspan ? (
													<td rowSpan='2'>
														<div className={`range ${yearDiffDirection}`}>
															<div className='text'>{yearDiff}</div>
															<div className='icon'></div>
														</div>
													</td>
												) : null}
											</tr>
										);
									})}
								</tbody>
							</table>
						</div>

						<div className='notes'>
							<div className='flex-row'>備註 : </div>

							<div className='flex-row'>
								<div className='num'>(1)</div>
								<div className='text'>指前1年度最後1營業日之淨值，當年度掛牌之ETF則基準日為掛牌日之淨值。</div>
							</div>

							<div className='flex-row'>
								<div className='num'>(2)</div>
								<div className='text'>指前1年度最後1營業日起累積漲跌幅%；當年度掛牌之ETF則基準日為掛牌日起累積漲跌幅％。</div>
							</div>

							<div className='flex-row'>
								<div className='num'>(3)</div>
								<div className='text'>
									上開ETF追蹤指數，以當日由彭博資訊(Bloomberg)所取得匯率換算為新臺幣計價價格。如當日無法取得彭博資訊(Bloomberg)所提供之匯率，以路透社(Reuters)所提供之匯率替代之。如均無法取得前述匯率時，則以彭博資訊(Bloomberg)最近之收盤匯率為準。因評價時點及資訊源不同，與實際基金評價匯率或有差異，上述訊息僅供參考，大華銀投信與指數公司不擔保其完全正確無誤，投資人做任何相關規劃與決定之前，仍應請教專業人員針對投資人自身個別的情況提供專業意見，以符合投資人專屬的投資需求。
								</div>
							</div>

							<div className='flex-row'>
								<div className='num'>(4)</div>
								<div className='text'>上表之ETF基金有收益分配者，經本公司公告配息金額後，【今年以來漲跌幅】、【今年以來追蹤偏離度】，均將年度累計配息金額納入公式計算。</div>
							</div>

							<div className='flex-row'>
								<div className='num'>(5)</div>
								<div className='text'>*配息基金。此類基金之受益分配可能來自於先前或上年度基金還未分配之資產(現金股利、利息收入等項目)，使得基金實際進行受益分配時將產生追蹤差距，請投資人可連結至大華銀投信網頁查詢相關配息情況。</div>
							</div>

							<div className='flex-row'>
								<div className='num'>(6)</div>
								<div className='text'>
									上述資訊為服務投資人而提供，內容僅供參考，本公司不負擔保其正確性或即時性之責任，如有任何疏漏、錯誤，或因網路、系統問題，包括但不限於斷線、壅塞、延宕等情事，或者其他因使用、取得、下載本網頁資料所造成之任何損害，本公司均不負賠償責任。使用以上資料請投資人自行評估考量並承擔風險。
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default ETFIndexTrack;
